module.exports = __webpack_public_path__ + "img/logout.49ba2ce4.svg";